import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, NgForm, NgModel, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { PasseLivreLatamCrewService } from 'src/app/core/services/passe-livre/passe-livre-latam-crew.service';
import { CrewInfo } from 'src/app/models/CrewInfo';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { CREW_INFO, getItemFromSessionStorage } from 'src/app/utils/SessionStorageUtil';

@Component({
    selector: 'app-change-bp',
    templateUrl: './change-bp.component.html',
    styleUrls: ['./change-bp.component.scss'],
    standalone: false
})
export class ChangeBpComponent implements OnInit {
  
  confirmed: boolean;

  form: FormGroup = new FormGroup({
    from: new FormControl('', Validators.required),
    to: new FormControl('', Validators.required)
  })

  @ViewChild('bpModel') bpModel: NgModel;

  constructor(private passeLivreService: PasseLivreLatamCrewService,
              private notificationService: NotificationService,
              private router: Router,
              private dialogRef: MatDialogRef<ChangeBpComponent>
              ) {}

  ngOnInit(): void {
    const crewInfo = getItemFromSessionStorage<CrewInfo>(CREW_INFO);

    if (crewInfo && crewInfo.code.value) {
      this.passeLivreService.getCrewByBpTest(crewInfo.code.value).subscribe({
        next: (crew) => {
          this.form.controls.from.setValue(crew.bp);
          this.form.controls.to.setValue(crew.bpTest);
        }
      });
    }
  }

  confirm(): void {
    this.confirmed = true;

    const changeBpRequest = { to: this.form.controls.to.value };

    if (this.form.valid) {      
      this.passeLivreService.changeBp(changeBpRequest).subscribe({
        next: () => {
          this.notificationService.success('BP alterado com sucesso! A tela será recarregada.');
          this.dialogRef.close();

          setTimeout(() => {
            this.router.navigateByUrl('/home', { skipLocationChange:false }).then(() => {
              location.reload();
            });
          }, 2000);
        },
        error: () => {
          this.notificationService.error('Erro inesperado ao alterar o BP!');
        }
      });

    }
  }
}
